<template>
  <b-container
    class="d-flex align-items-center justify-content-center px-0"
    :class="isMobile ? 'py-2' : 'py-3'"
    fluid>
    <div class="w-100 d-flex align-items-center justify-content-between">
      <h4 class="mb-0" :class="isMobile ? 'h6' : 'h4'">{{ title }}</h4>
      <div>
        <AddUserIcon v-if="displayAddUser"/>
        <BulkUploadIcon v-if="displayBulkUpload"/>
        <p
          class="text-primary"
          @click="$router.go(-1)"
          v-if="displayBack">Back</p>
      </div>
    </div>
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex'
import BulkUploadIcon from '../Icons/BulkUploadIcon'
import AddUserIcon from '../Icons/AddUserIcon'

export default {
  name: 'TopBar',
  components: {
    AddUserIcon,
    BulkUploadIcon
  },
  computed: {
    ...mapGetters(['group', 'getMessages']),
    title() {
      if (this.$route.path === '/group/users') {
        return this.group.name
      } else {
        return this.$route.meta.title
      }
    },
    isMobile() { return window.innerWidth < 1200 },
    displayAddUser() {
      return (this.$route.path === '/user' ||
        this.$route.path === '/account' ||
        this.$route.path === '/group/users')
    },
    displayBulkUpload() {
      return this.$route.path === '/group/users'
    },
    displayBack() {
      return this.isMobile && this.$route.path === '/messages' && this.$route.query.messageId && this.getMessages.length > 1
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/components/Layout/TopBar.vue?2d038fe5